import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UserManagementLayer from "../components/UserManagementLayer";

const UserManagementPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="User Management (B2C & B2B)" />
        <UserManagementLayer />
      </MasterLayout>
    </>
  );
};

export default UserManagementPage;
